import { render, staticRenderFns } from "./ClientsLoader.vue?vue&type=template&id=7b7eeffe&scoped=true&"
import script from "./ClientsLoader.vue?vue&type=script&lang=js&"
export * from "./ClientsLoader.vue?vue&type=script&lang=js&"
import style0 from "./ClientsLoader.vue?vue&type=style&index=0&id=7b7eeffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7eeffe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientsLoader.vue
// module id = null
// module chunks = 